export default '/types/@slug'
